import { Box, styled } from "@mui/material";
import { Fragment } from "react";

const Wrapper = styled(Box)(({ theme }) => ({
  paddingLeft: "1rem",
  paddingRight: "1rem",
  transition: "all 0.3s",
  [theme.breakpoints.down(1200)]: {
    width: "100%",
    marginLeft: 0,
    paddingLeft: ".8rem",
    paddingRight: ".8rem",
  },
}));
const InnerWrapper = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up("lg")]: {
    //maxWidth: 1600,
    margin: "auto",
  },
})); // --------------------------------------------

// --------------------------------------------
const LayoutBodyWrapper = ({ children, sx }) => {
  return (
    <Fragment>
      <Wrapper id="layout-body-wrapper-wrapper" sx={sx}>
        <InnerWrapper id="layout-body-wrapper-inner">{children}</InnerWrapper>
      </Wrapper>
    </Fragment>
  );
};

export default LayoutBodyWrapper;
